<div class="container">
  <h3>{{'COMPLETED_EXAM_PREVIEW_DIALOG.TITLE' | translate}}</h3>
  @if (isLoading) {
    <div class="container__message">
      <p class="container__message__text">{{'COMPLETED_EXAM_PREVIEW_DIALOG.MESSAGE' | translate}}</p>
      <p>{{index}}/{{pageCount}}</p>
    </div>
  }
  <div #pdfPreview class="pdfPreview"></div>
  <div>
    <input type="checkbox" id="submit" name="submit" [ngClass]="{'disabled': sendClicked()}" [ngModel]="examChecked()" (ngModelChange)="examChecked.set($event)">
    <label for="submit">{{'EXAM_UNLOCK_DIALOG.CONFIRMATION_MESSAGE' | translate}}</label>
  </div>
  <div class="buttonContainer">
    <input  type="button"
      class="cb-btn left"
      [ngClass]="{'disabled': sendClicked()}"
      value="{{'COMPLETED_EXAM_PREVIEW_DIALOG.GO_BACK' | translate}}"
      (click)="goBack()"
      >
      <input  type="button"
        class="cb-btn right"
        [ngClass]="{'disabled': !readyToSubmit()}"
        value="{{'COMPLETED_EXAM_PREVIEW_DIALOG.SAVE' | translate}}"
        (click)="save()"
        >
      </div>
    </div>